import { useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/Button";
import { BackgroundMedia } from "../profiler/components/BackgroundMedia";

type LandingPageProps = {
  backgroundPath: string;
  subtitle: string;
  title: string;
  description: string;
  path: string;
};

export const LandingPage = ({
  backgroundPath,
  subtitle,
  title,
  description,
  path,
}: LandingPageProps) => {
  const navigate = useNavigate();
  return (
    <div className="relative h-full w-full">
      <BackgroundMedia backgroundPath={backgroundPath} />
      <div className="relative z-10 h-full w-full text-white flex flex-col justify-end">
        <div className="flex flex-col items-center mb-16 gap-8">
          <div className="flex flex-col items-center">
            <h2 className="text-[40px] leading-[40px] font-garamond-italic italic">
              {subtitle}
            </h2>
            <h1 className="text-[80px] leading-[80px] font-bebas-kai">
              {title}
            </h1>
            <p className="text-[14px] leading-[21px] font-minion">
              {description}
            </p>
          </div>
          <Button variant="default" onClick={() => navigate(path)}>
            <p className="p-6">Start</p>
          </Button>
        </div>
      </div>
    </div>
  );
};
